export default function validate() {
  return [{
    type: 'validate',
    field: 'validate',
    value: []
  }];
}